import React, { Component } from "react";

import dostalek from '../../images/lectures/dostalek.jpg';
import kincl from '../../images/lectures/kincl.jpg';
import panovska from '../../images/lectures/panovska.jpg';

class Lectures extends Component {
    render() {
        return(
            <>
            <section id="lecture">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="feature_header text-center">
                                <h3 class="feature_title">Lecturers</h3>
                                <p> Academic part is provided by <strong>Department of Biotechnology</strong>, VŠCHT.
            			        Specifically by people named bellow. </p>
                                <div class="divider"></div>
                                    <br /><br />
                                    <p>
                                    <table  style={{'width':"100%"}} cellspacing="50" align="center">
              	                        <tr>
                                            <td align="center"><img src={kincl} alt="" class="img-responsive" style={{"height": "200px"}}></img></td>
            		                        <td align="center"><img src={dostalek} alt="" class="img-responsive" style={{"height": "200px"}}></img></td>
            		                        <td align="center"><img src={panovska} alt="" class="img-responsive" style={{"height": "200px"}}></img></td>
                                        </tr>
              	                        <tr>
                                            <td><strong>Tomáš Kinčl, MSc</strong></td>
                                            <td><strong>Prof. Pavel Dostálek, PhD</strong></td>
                                            <td><strong>doc. Dr. Ing. Zdeňka Panovská</strong></td>
            	                        </tr>
              	                        <tr>
                                            <td>kinclo@vscht.cz</td>
                                            <td>Pavel.Dostalek@vscht.cz</td>
                                            <td>zdenka.panovska@vscht.cz</td>
                                        </tr>
                                    </table>
                                    </p>
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </>
        )
    }
}
export default Lectures;